import React from 'react';
import { NamingProjectScore, pctTone } from './types';
import * as fmt from '../../lib/format';

interface Props {
  score: NamingProjectScore;
  selected: boolean;
  onSelect: (projectKey: string | null) => void;
}

// One project: share of clear titles this month, with the last six months as bars.
// Pressing selects the project as the queue filter; pressing again clears it.
export default function ScoreCard({ score, selected, onSelect }: Props) {
  const pct = score.pct_clear;
  const label = fmt.percent(pct);
  return (
    <button
      type="button"
      onClick={() => onSelect(selected ? null : score.project_key)}
      aria-pressed={selected}
      className={`group w-full rounded-2xl bg-white p-4 text-left shadow-sm ring-1 transition-[transform,box-shadow,ring-color] duration-150 ease-out motion-reduce:transition-none active:scale-[0.98] hover:shadow-md ${selected ? 'ring-2 ring-blue-500' : 'ring-gray-200/70 hover:ring-gray-300'}`}
    >
      <div className="flex items-baseline justify-between gap-2">
        <div className="min-w-0">
          <div className="truncate text-xs font-semibold uppercase tracking-wider text-gray-500">{score.project_key}</div>
          <div className="truncate text-sm text-gray-600">{score.project_name ?? ''}</div>
        </div>
        <div className={`text-2xl font-bold tabular-nums tracking-tight ${pctTone(pct)}`}>{label}</div>
      </div>
      <div className="mt-1 text-xs text-gray-500">
        {score.total === 0 ? 'No tickets created this month' : `${score.clear} of ${score.total} titles clear`}
      </div>
      <div className="mt-3 flex h-7 items-end gap-1" aria-hidden="true">
        {score.trend.map((t, i) => {
          const isCurrent = i === score.trend.length - 1;
          const h = t.pct_clear === null ? 2 : Math.max(2, Math.round((t.pct_clear / 100) * 28));
          return (
            <div
              key={t.period}
              title={`${t.period}: ${t.pct_clear === null ? 'no tickets' : `${fmt.percent(t.pct_clear)} of ${t.total}`}`}
              className={`flex-1 rounded-sm ${isCurrent ? 'bg-blue-500' : 'bg-blue-200'} ${t.pct_clear === null ? 'opacity-40' : ''}`}
              style={{ height: `${h}px` }}
            />
          );
        })}
      </div>
    </button>
  );
}
